import { useAppContext } from "providers/AppProvider";
import React from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";

const BranchResultStep = () => {
  const { tableData } = useSelector((state) => state.branch);
  const {
    config: { theme },
  } = useAppContext();
  const columns = [
    {
      name: "#",
      selector: (row) => row.rowNum - 1,
      width: "60px",
    },

    {
      name: "Branch Name",
      selector: (row) => row["Branch Name (Eng)"] || "-",
      sortable: true,
    },
    {
      name: "Nphies ID",
      selector: (row) => row["Nphies ID"] || "",
      sortable: true,
    },
    {
      name: "CCHI ID",
      selector: (row) => row["CHI No"] || "",
      sortable: true,
    },
    {
      name: "Branch Type",
      selector: (row) => row["Branch Type"] || row?.branch_type?.title || "",
      sortable: true,
    },

    {
      name: "Status",
      cell: (row) => {
        if (row.status === "duplicate") {
          return <span className="badge bg-warning">Duplicate</span>;
        }
        return row.isValid ? (
          <span className="badge bg-success">Valid</span>
        ) : (
          <span className="badge bg-danger">Invalid</span>
        );
      },
      width: "100px",
    },
  ];
  return (
    <DataTable
      columns={columns}
      data={tableData}
      pagination
      theme={theme}
      highlightOnHover
      dense
    />
  );
};

export default BranchResultStep;
